import { types } from "../action-types";

const initialState = {
    loading: false,
    success: false,
    error: false,
};

const updateEmpAlbumsReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.UPDATE_EMP_ALBUMS_REQUESTED:
            return {
                ...state,
                loading: true,
            };

        case types.UPDATE_EMP_ALBUMS_SUCCESS:
            return {
                ...state,
                loading: false,
                success:true,
                error: false,
            };
        case types.UPDATE_EMP_ALBUMS_FAILURE:
            return {
                ...state,
                loading: false,
                success:false,
                error: true,
            };
        case types.UPDATE_EMP_ALBUMS_RESET:
                return {
                    ...state,
                    success:false,
                };  
        default:
            return state;
    }
};
export default updateEmpAlbumsReducer;
